import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';

const url = `${PREFIX_URL}/v01/inboxThread/checkReplyEmail`;

type CheckReplyEmailResponse = {
  emails: any;
  hasChanges: boolean;
  newEmail?: string;
};

export type CreateReplyDTO = {
  to: string;
  cc: string;
  html: string;
  raw: string;
  files: any[];
  projectId: string;
  threadId: number;
  action: 'Reply Only' | 'Reply All';
};

export const getCheckReplyEmail = (params): Promise<CheckReplyEmailResponse> => {
  return axios.post(url, {
    ...params,
  });
};

export const checkReplyEmailKeys = {
  list: ['checkReplyEmail'] as const,
};

type QueryFnType = typeof getCheckReplyEmail;

type useCheckReplyEmailOptions = {
  projectId: string;
  threadId: number;
  emails: any[];
  config?: QueryConfig<QueryFnType>;
};

export const useCheckReplyEmail = ({
  threadId,
  config,
  ...otherParams
}: useCheckReplyEmailOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [...checkReplyEmailKeys.list, threadId, otherParams],
    queryFn: () => getCheckReplyEmail({ threadId, ...otherParams }),
    staleTime: Infinity,
    ...config,
  });
};
